import type { ComponentProps } from 'react';

import Chevron from '@/public/icons/chevron.svg';

export const IconChevron = ({ ...props }: ComponentProps<'svg'>) => {
  return <Chevron {...props} />;
};
